module.exports = __webpack_public_path__ + "img/ph_manange5.2fcc88fa.png";